import React from 'react';
import Navbar from '../components/layout/Navbar';
import Banner from '../components/sections/Banner';
import AboutUs from '../components/sections/AboutUs';
import WhatIsStreetWorkout from '../components/sections/WhatIsStreetWorkout';
import Course from '../components/sections/Course';
import TrainerProfiles from '../components/sections/TrainerProfiles';
import Testimonials from '../components/sections/Testimonials';
import Contact from '../components/sections/Contact';
import Policy from '../components/sections/Policy';
import Disclaimer from '../components/sections/Disclaimer';
import Footer from '../components/layout/Footer';

const HomePage: React.FC = () => {
  return (
    <div className="home-page">
      <Navbar />
      <Banner />
      <AboutUs />
      <WhatIsStreetWorkout />
      <Course />
      <TrainerProfiles />
      <Testimonials />
      <Contact />
      <Disclaimer />
      <Policy />
      <Footer />
    </div>
  );
};

export default HomePage;
